import _ from "ES/lib/lodash";
import React from "ES/lib/react";
// import radio from "ES/lib/react-pubsub-via-radio.js/radio";
// import esUtils from "ES/utils/esUtils";
import FormMixin from "react-loose-forms";
// import FormUtils from "../../../utils/FormUtils";
import ErrorAlert from "ES/widgets/ErrorAlert";
import ModalForm from "../../widgets/ModalForm";
import SubmitButton from "../../widgets/SubmitButton";
import ezVerticalFields from "react-loose-forms.bootstrap3/layouts/ezVerticalFields";
import RadioServiceMixin from "ES/lib/react-pubsub-via-radio.js/RadioServiceMixin";
import AuthedUserSession from "../../../utils/AuthedUserSession";
import FormUtils from "../../../utils/FormUtils";

require("./ComplianceModal.less");

let DaForm = React.createClass({
  mixins: [FormMixin],
  getInitialValues: function (props) {
    return {};
  },
  buildSchema: function () {
    return {
      initials: {
        label: "Initial Here",
        type: "text",
        validate: FormUtils.v.required
      }
    };
  },

  render: function () {
    let {is_sending, commission, CloseModal} = this.props;

    return <form onSubmit={this.Form_onSubmit}>
      <div className="modal-body">
        <p>
          It looks like the message you’re about to send includes a way for the buyer to respond to you outside of this message board (phone number, email address, etc.).
        </p>
        <p className="text-muted">
          As a reminder, the Marketplace Finder’s Fee applies whether the buyer pays through the platform or pays you directly. <i>Jobs paid through the platform can increase your search rank and move you higher in results.</i>
        </p>
        <div className={"row"} style={{marginTop: "2em", marginBottom: "2em"}}>
          <div className={"col-sm-2"}>
            {ezVerticalFields(this, [
              ["initials"],
            ])}
          </div>
          <div className={"col-sm-9"}>
            <br />
            <p>
              I understand and accept the <span className="commission"><b>{commission > 0 ? commission + '%' : ''} finder’s fee</b></span> due for work resulting from this lead.
            </p>
          </div>
        </div>
      </div>

      <div className="modal-footer">
        <SubmitButton is_waiting={is_sending}>
          Accept &amp; Send Message
        </SubmitButton>
        {!is_sending && <button className="btn btn-default" onClick={CloseModal}>Change Message</button>}
      </div>
    </form>;
  }
});

export default React.createClass({
  mixins: [RadioServiceMixin],
  RadioService_setup(){
    return {
      Marketplace_acceptCompliance: {
        key(){
          let {eid, sid} = this.props;
          return eid + "|" + sid;
        },
        on: {
          succeeded(){
            let {eid, sid, message} = this.props;
            if (_.isFunction(this.props.onAcceptCompliance)) {
              this.props.onAcceptCompliance({
                eid: eid,
                sid: sid,
                message: message,
                skip_compliance: true
              });
            }
            this.props.onClose();
          }
        }
      }
    };
  },
  __onSubmit: function (data) {
    this.RadioService_callService("Marketplace_acceptCompliance", {
      sid: this.props.sid,
      event_id: this.props.eid,
      finders_fee: this.props.commission,
      user_agent: window.navigator.userAgent,
      created: new Date(),
      initials: data.initials,
      login: AuthedUserSession.MY_USERNAME,
      extra: data,
      skip_log: true
    });
  },
  render: function () {
    let {sid, eid, commission, onClose} = this.props;
    let ajax = this.state.Marketplace_acceptCompliance;

    return <ModalForm
      title="Direct contact information"
      buttons={[]}
      raw_body={true}
      onClose={ajax.waiting
        ? null
        : onClose}
    >
      <div className="Marketplace-ComplianceModal">
        <ErrorAlert message={ajax.error}/>

        <DaForm
          sid={sid}
          eid={eid}
          commission={commission}
          onSubmit={this.__onSubmit}
          is_sending={ajax.waiting}
          CloseModal={onClose}
        />
      </div>
    </ModalForm>;
  }
});


// WEBPACK FOOTER //
// ./src/components/marketplace/MyMessagesTab/ComplianceMessageModal.js